import { SerializedStyles, css } from "@emotion/react";

import { black, grey } from "../../styles/variables";

export const container = (loaded: boolean): SerializedStyles => css`
  background: ${loaded ? black : grey};
  border-radius: 4px;
  overflow: hidden;
`;

export const img = css`
  display: block;
  margin: 0 auto;
  max-width: 100%;
  height: 100%;
`;
